export { useWavesurfer } from "@wavesurfer/react";
